import { ScoringPrevStatsComponent } from './scoring-prev-stats.component';

export default angular
  .module('sfMobile.components.scoring-prev-stats', [])
  .component('sfScoringPrevStats', ScoringPrevStatsComponent).name;
